<template>
	<div class="allchain">
		<leftnav class="fl" mkcode="E" :itemcode="yj_itemcode"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<div class="index_left_centerpage">
				<div class="whitebox right_topbox">
                    <div class="right_boxtitle map_title_tab">
						<span class="title" :class="{'current':navValue == list.value}" @click="navValue = list.value;ajaxsearchcompany(1)" v-for="(list) in navList" :key="list.value">{{list.label}}</span>
					</div>
                    <landFilterCom class="mt-3" v-show="navValue == 1" @search="searchList"></landFilterCom>
				</div>
				<div class="whitebox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<div class="pb-3">
                        <table border="0" cellspacing="0" cellpadding="0" class="land_table">
							<tr>
								<th>序号</th>
                                <th>行政区</th>
								<th>项目名称</th>
								<th>总面积</th>
                                <th>土地用途</th>
                                <th>土地使用权人（项目公司）</th>
								<th>投资主体</th>
                                <th style="width: 100px;">投资来源地</th>
                                <th style="width: 100px;">签订日期</th>
                                <th style="width: 100px;">操作</th>
							</tr>
                            <tr v-for="(item,index) in enterpristlist" :key="item.stockcode">
                                <td>{{(page-1)*pageSize+index+1}}</td>
                                <td>{{item.area || '-'}}</td>
                                <td class="title" @click="handlerLinkLocal('/landDetail?id='+item.id+'&pageType='+navValue)">{{item.projectName}}</td>
                                <td>{{item.size.toFixed(2)}}</td>
                                <td>{{item.purpose}}</td>
                                <td :class="item.stockCode!=''? 'title' : ''" @click="item.stockCode!=''? routerlinkid('/enterprises',item.stockCode) : ''" >{{item.owner}}</td>
                                <td :class="item.sourceStockCode!=''? 'title' : ''" @click="item.sourceStockCode!=''? routerlinkid('/enterprises',item.sourceStockCode) : ''" >{{item.sourceEnterprise || '-'}}</td>
                                <td>{{item.sourceArea|| '-'}}</td>
                                <td style="width: 100px;">{{item.time ||'-'}}</td>
                                <td v-if="item.pushStatus == 0" class="collectfont1" :class="item.thread?'redfont':''" style="width: 100px;">
                                    <span @click="landThreadToggle(item,'land')">{{item.thread == 0 ? '加入' : '移除'}}线索管理</span>
                                </td>
                                <td v-else style="width: 100px;">已推送</td>
                                
                            </tr>
                    </table>
					</div>
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler"></zpagenav>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import landFilterCom from "./inc/landFilterCom.vue";
export default {
	name: 'landSearch',
    components: {
        landFilterCom
    },
	computed: {
		...mapState({
			// isCollapse: (state) => state.app.isCollapse,
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "",
			curWebsite: this.$api.getWebsiteType(),
			userdata: {},
			yj_itemcode: "E02",
			page: 1, //显示的是哪一页
			haspage: true, //是否还有下一页
			pageSize: 20, //每一页显示的数据条数
			total: 0, //记录总数
			totalPage: 1,
			maxPage: 10, //最大页数 
            enterpristlist: [],
            navList: [
                {value:1,label:'拿地项目库检索'},
                {value:3,label:'拿地项目库线索管理'},
            ],
            navValue: 1,
            searchData: {},
		}
	},
	created() {
        this.bus.$emit('loading', false);
    },
	mounted() { 
        this.ajaxsearchcompany(1);
    },
	methods: {
        searchList(filterData){
            //处理一下filterData里面为‘’和0的数据
            for(let key in filterData){
                if(filterData[key] == '' || filterData[key] == 0){
                    delete filterData[key];
                }
            }
            this.searchData = filterData;
            console.log('this.searchData',this.searchData);
            this.ajaxsearchcompany(1);
        },
        addClue(item){ 
        },
        ajaxsearchcompany(pages) {
            this.page = pages ? pages : 1;
            this.bus.$emit('loading', true);
            let params = {
                page: this.page,
                thread:this.navValue == 1 ? '0' : '1',
                pageSize: this.pageSize,
                ...this.searchData
            };
           this.$axios.get(this.$api.metall.Land.List(), { params: params }).then((res) => {
               if (res.data.success) { 
                this.enterpristlist = res.data.list;
                this.totalPage = res.data.totalPage;
                this.total = res.data.totalRecord;
                this.pageSize = res.data.pageSize;
                this.bus.$emit('loading', false);
               } else {
                //    this.$message.error(res.data.message);
                    this.bus.$emit('loading', false);
               }
           })
        },
        pageHandler(page) { 
            this.page = page;
            this.ajaxsearchcompany(page);
        },
    },
}
</script>

<style lang="scss" >

.collectfont1{
    font-size: 14px;
    color: #305ea3;
    cursor: pointer;
    &:hover{
        color: #f19d00;
    }
}
.land_table{
    margin:  0 auto;
    border: 1px solid #f2f2f2; 
    background: #fff;
    width: 95%;
    font-size: 14px;
    .title{
        cursor: pointer;
        color: #305ea3;
        &:hover{
            color: #f19d00;
            text-decoration: underline;
        } 
    }
    th{
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    height: 54px;
    line-height: 54px;
    background: #f2f8fe;
    white-space: nowrap;
    padding: 0 10px;
    border-right: 1px solid #dcdcdc;
    }
    tr{
        height: 40px;
        border-bottom: 1px solid #dcdcdc;
        td{
            text-align: center;
            border-right: 1px solid #dcdcdc;
            padding: 0 10px;
            border-bottom: 1px solid #dcdcdc;
        }
    }
}
</style>